var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPeopleCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23189_335568)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8893 11.8887C14.3438 11.8887 16.3336 9.89892 16.3336 7.44436C16.3336 4.98981 14.3438 3 11.8893 3C9.43472 3 7.44492 4.98981 7.44492 7.44436C7.44492 9.89892 9.43472 11.8887 11.8893 11.8887ZM11.8893 10.2221C13.4234 10.2221 14.667 8.97846 14.667 7.44436C14.667 5.91027 13.4234 4.66664 11.8893 4.66664C10.3552 4.66664 9.11155 5.91027 9.11155 7.44436C9.11155 8.97846 10.3552 10.2221 11.8893 10.2221ZM21.9871 14.366C22.28 14.0731 22.28 13.5982 21.9871 13.3053C21.6942 13.0124 21.2194 13.0124 20.9265 13.3053L17.1462 17.0856L15.591 15.5303C15.2981 15.2374 14.8232 15.2374 14.5303 15.5303C14.2375 15.8232 14.2375 16.2981 14.5303 16.591L16.5356 18.5962C16.5578 18.6264 16.5826 18.6553 16.6099 18.6826C16.9028 18.9755 17.3776 18.9755 17.6705 18.6826L21.9871 14.366ZM7.44436 12.9998L13.9997 13C13.6295 13.4928 13.3482 14.0563 13.1798 14.6666L7.99991 14.6665C6.15899 14.6665 4.66664 16.1588 4.66664 17.9997L13.416 17.9998C13.6935 18.6351 14.0992 19.2015 14.6004 19.6665L3 19.6664V17.4442C3 14.9896 4.98981 12.9998 7.44436 12.9998Z",
    fill: "#2D72FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23189_335568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPeopleCheckmark);
export default __webpack_public_path__ + "static/media/icn_people_checkmark.6e3d926b823cfeb986a654e83abbb6ec.svg";
export { ForwardRef as ReactComponent };